module.exports = __webpack_public_path__ + "img/logo.ece3cebf.png";